module.exports = __webpack_public_path__ + "static/media/goodnest4.71a81abb.jpg";